import { createAction } from '@reduxjs/toolkit';
import { FileUploadState } from '@store/files/types';
import { produce } from 'immer';

export class UploadFileFailure {
  static get action() {
    return createAction<string>('files/UPLOAD_FILE_FAILURE');
  }

  static get reducer() {
    return produce(
      (
        draft: FileUploadState,
        { payload: uploadId }: ReturnType<typeof UploadFileFailure.action>,
      ) => {
        delete draft[uploadId];
        return draft;
      },
    );
  }
}
